import { PropellerError } from 'lib/persistence/http/error/PropellerError';

export async function readJsonResponse<T>(response: Response, invalidMessage: string = 'Invalid API response'): Promise<T> {
	const contentType = response.headers.get('content-type')?.toLowerCase() ?? '';
	if (!contentType.includes('application/json') && !contentType.includes('+json')) {
		throw new PropellerError(invalidMessage, String(response.status));
	}

	try {
		return await response.json() as T;
	} catch (e) {
		throw new PropellerError(invalidMessage, String(response.status));
	}
}
